import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
div {
  font-family: 'Nimbus Sans Reg', sans-serif;
  font-size: 20px;
  font-weight: normal;
    font-size: 20px;
    color: #3b3b3b;
    text-align: center;
}
`;

export default styles;